import React from 'react';

import awsRumActionNames from '../../consts/aws/awsRumActionNames';
import {CloseIcon} from '../Icons/CloseIcon';
import RoundedIcon from '../Icons/RoundedIcon';
import NavigationButton from './NavigationButton';

const CloseButton = (props) => {
    return (
        <NavigationButton rumActionName={awsRumActionNames.CLOSE} isRightAlign {...props}>
            <RoundedIcon>
                <CloseIcon />
            </RoundedIcon>
        </NavigationButton>
    );
};

export default CloseButton;
